import { HandlerDataModel } from "./Handler";
import { IInitialState } from "us.collection/reducers/Handler/Interfaces";

export const initialState: IInitialState = {
  handler: HandlerDataModel,
};
